/**
 * Familias visuales Flyer V2 — composición distinta (no solo color).
 * Compatible con producto o pieza futura (combo) vía `subject`.
 */

export const FLYER_TEMPLATES = [
  {
    key: 'impacto',
    label: 'Impacto',
    blurb: 'Producto grande y precio dominante.',
    requiresImage: true,
    layout: 'impacto'
  },
  {
    key: 'oferta',
    label: 'Oferta',
    blurb: 'Descuento / precio como protagonista.',
    requiresImage: false,
    layout: 'oferta'
  },
  {
    key: 'minimal',
    label: 'Minimal',
    blurb: 'Aire, producto y marca limpia.',
    requiresImage: true,
    layout: 'minimal'
  },
  {
    key: 'comercial',
    label: 'Comercial',
    blurb: 'Equilibrio mensaje + producto + precio.',
    requiresImage: false,
    layout: 'comercial'
  },
  {
    key: 'sin_foto',
    label: 'Sin fotografía',
    blurb: 'Tipografía y color; sin depender de imagen.',
    requiresImage: false,
    prefersNoImage: true,
    layout: 'sin_foto'
  }
];

export function getFlyerTemplate(key) {
  return FLYER_TEMPLATES.find((t) => t.key === key) || FLYER_TEMPLATES[0];
}

/** Evita plantillas incompatibles (ej. sin imagen → no forzar Impacto/Minimal). */
export function compatibleFlyerTemplates(hasImage) {
  if (hasImage) return FLYER_TEMPLATES;
  return FLYER_TEMPLATES.filter((t) => !t.requiresImage);
}

export function suggestFlyerTemplate(hasImage) {
  if (!hasImage) {
    return FLYER_TEMPLATES.find((t) => t.key === 'sin_foto') || FLYER_TEMPLATES[0];
  }
  return FLYER_TEMPLATES.find((t) => t.key === 'impacto') || FLYER_TEMPLATES[0];
}

export const FLYER_CTA_PRESETS = [
  'Consultanos',
  'Pedilo ahora',
  'Escribinos',
  'Aprovechá la oferta',
  'Disponible ahora'
];

export const FLYER_TITLE_PRESETS = ['OFERTA', 'IMPERDIBLE', 'NUEVO', 'PROMO'];
